import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckmark1Small: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCheckmark1Small"><Path fillRule="evenodd" clipRule="evenodd" d="M17.2835 7.51131L11.0738 17.4468L6.68933 13.0623L7.74999 12.0016L10.8012 15.0528L16.0115 6.71631L17.2835 7.51131Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCheckmark1Small;
